import { render, staticRenderFns } from "./introduce.html?vue&type=template&id=2f539878&scoped=true&"
import script from "./introduce.js?vue&type=script&lang=js&"
export * from "./introduce.js?vue&type=script&lang=js&"
import style0 from "./introduce.sass?vue&type=style&index=0&id=2f539878&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f539878",
  null
  
)

component.options.__file = "introduce.vue"
export default component.exports